import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    color: 'rgba(0, 0, 0, 0.87)',
    background: '#fff',
    overflow: 'initial',
  },
  userStats:{
    heigth: 500,
  },
  checkBoxText: {
    alignContent: 'center',
  },
  checkBox: {
    padding: 0,
  },
  inputStyle: {
    font: 'inherit',
    width: '100%',
    border: 0,
    height: '1.1875em',
    margin: '0',
    padding: '6px 0 7px',
    display: 'block',
    minWidth: 0,
    boxSizing: 'content-box',
    background: 'none',
  },
  statsDivider:{
    border: '50px',
    borderLeft: 2,
    borderColor:'black'
  },
  RightTab:{
    borderStyle:'outset',
    borderWidth:'thin',
    borderBottomWidth:'inherit',
    borderRightWidth:'inherit'
  },
  LeftTab:{
    borderStyle:'outset',
    borderWidth:'thin',
    borderBottomWidth:'inherit',
    borderRightWidth:'inherit',
    borderLeftWidth: 'inherit',
  },
  padding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  // inputDateAction:{
  //   position:'absolute',
  //   left:0,
  //   width: '80px',
  // },
  marginTable:{
    marginLeft: 16,
    marginRight: 10,
  },
  ListItemWithIcon:{
    marginRight: 10,
    marginLeft:4
  },
}));
